import script from "./MZoneHistoryTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MZoneHistoryTable.vue?vue&type=script&setup=true&lang=ts"

import "./MZoneHistoryTable.vue?vue&type=style&index=0&id=ca2461f8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca2461f8"]])

export default __exports__